import $ from 'jquery'
import {
  cascadeSelector,
  hideSelector,
  showSelector,
} from './toggle_prefix_selectors'

// Toggle using prefix
//   Can be used with any input or select. Although might only work properly with radio inputs + selects
//   Although, there are now obvious differences with the implementation of data-radio-toggle-prefix, I am not sure why or if that was necessary.
//
//   if toggle element have sub toggle controller(`togglePrefixSelector`) that should be checked ->
//   add to it class ${prefix}Cascade-${val}
//
//   Optional: data-toggle-prefix-scope="SELECTOR" scopes show/hide to
//   $(trigger).closest(SELECTOR) so repeated cards with the same prefix
//   classes (e.g. choice menu options) don't toggle each other globally.

const togglePrefixSelector =
  'input[data-toggle-prefix],select[data-toggle-prefix]'

function scopeRoot($trigger) {
  const scopeSelector = $trigger.data('toggle-prefix-scope')
  if (!scopeSelector) return null
  const $root = $trigger.closest(scopeSelector)
  return $root.length ? $root : null
}

function findWithin($root, selector) {
  return $root ? $root.find(selector) : $(selector)
}

$(document).on(
  'change.toggle-prefix toggle-prefix',
  'input[data-toggle-prefix],select[data-toggle-prefix]',
  function (e, data) {
    const $this = $(this)
    if ($this.is(':not(:radio)') || $this.is(':checked')) {
      const $root = scopeRoot($this)
      $this
        .data('toggle-prefix')
        .split(' ')
        .forEach((p) => {
          const prefix = p.trim()
          if (!prefix) return
          const val =
            $this.attr('type') == 'checkbox'
              ? $this.is(':checked')
              : $this.val()
          const isAjaxUpdating = window.Simplero?.state?.isAjaxUpdating
          const animate =
            ($this.data('toggle-prefix-animate') ?? true) && !isAjaxUpdating

          findWithin($root, hideSelector(prefix, val)).hideInputs(animate)

          if (window.js_dom_ready && (data?.cascade || !isAjaxUpdating)) {
            findWithin($root, showSelector(prefix, val)).showInputs(animate)
          }

          findWithin($root, cascadeSelector(prefix, val))
            .find(togglePrefixSelector)
            .trigger('toggle-prefix', { cascade: true })
        })
    }
  }
)

if (window.onDomChanged) {
  window.onDomChanged(togglePrefixSelector, 1000, function () {
    return this.trigger('toggle-prefix')
  })
} else {
  $(function () {
    $(togglePrefixSelector).trigger('toggle-prefix')
  })
}
